import { Outlet } from "react-router-dom";

function PackingListMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default PackingListMain;